import * as types from "../../constants/action-types";

export function setSurvey(payload) {
    return{type: types.SET_SURVEY, payload};
}

export function setTaxPercent(payload) {
    return{type: types.SET_TAX_PERCENT, payload};
}

export function showFirstLoginPopup(payload) {
    return{type: types.SHOW_FIRST_LOGIN_POPUP, payload};
}

export function setOrderStatusArr(payload) {
    return{type: types.ORDER_STATUS_ARR, payload};
}

export function setSortArr(payload) {
    return{type: types.SET_SORT_ARR, payload};
}

export function setContentWorlds(payload) {
    return {type: types.SET_CONTENT_WORLDS, payload};
}
export function translationsLoaded(payload) {
    return {type: types.SET_TRANSLATIONS, payload};
}
export function setMainMenu(payload) {
    return {type: types.SET_MAIN_MENU, payload};
}
export function iconTypes(payload) {
    return {type: types.SET_ICON_TYPES, payload};
}
export function setCitiesArr(payload) {
    return {type: types.SET_CITIES_ARR, payload};
}
export function setFooterLinks(payload) {
    return {type: types.SET_FOOTER_LINKS, payload};
}
export function setContentUrl(payload) {
    return{type: types.SET_CONTENT_URL, payload}
}
export function setAppStoreLink(payload) {
    return{type: types.SET_APP_STORE_LINK, payload}
}
export function setCategoriesArr(payload) {
    return{type: types.SET_CATEGORIES_ARR, payload}
}
export function setBenefitTypes(payload) {
    return{type: types.SET_BENEFIT_TYPES, payload}
}
export function set_default_geo(payload){
    return{type:types.SET_DEFAULT_GEO, payload}
}
export function setPopupTranslations(payload) {
    return{type:types.SET_POPUPS_TRANSLATIONS, payload};
}
export function setPolicyUrl(payload) {
    return{type:types.SET_POLICY_URL, payload};
}
export function setPrivacyPage(payload) {
    return{type:types.SET_PRIVACY_URL, payload};
}
export function setBannerInterval(payload) {
    return{type:types.SET_BANNER_INTERVAL, payload};
}

export function setFirstLoginReturn(payload) {
    return{type:types.SET_FIRST_LOGIN_RETURN, payload};
}

export function setWorkPlaces(payload) {
    return{type:types.SET_WORK_PLACES, payload};
}

/////banner for search discount on debit

export  function  setDiscountDebitBanner(payload){
    return {type: types.SET_DISCOUNT_DEBIT_BANNER,payload};
}

export function setSearchIsNetwork(payload){
    return {type: types.SET_SEARCH_IS_NETWORK,payload};
}
export function setUserData(payload) {
    return{type:types.SET_USER_DATA, payload};
}

export function setHotSearches(payload) {
    return{type:types.SET_HOT_SEARCHES, payload};
}
export function setBannersArr(payload) {
    return{type:types.SET_BANNERS_ARR, payload};
}

export function setBenefitLogged(payload) {
    return{type:types.SET_BENEFIT_TYPES_FOR_LOGGED_USERS, payload};
}

export function setVerificationCodeMaxAttempsError(payload) {
    return{type:types.SET_VERIFICATION_CODE_MAX_ATTAMPS_ERROR, payload}
}

export function setLockdownErr(payload) {
    return{type:types.SET_LOCKDOWN_ERR, payload}
}

export function setSubCategoriesMenu(payload) {
    return{type:types.SET_SUB_CATEGORIES_MENU, payload}
}

export function setMainCategoriesMenu(payload) {
    return{type:types.SET_MAIN_CATEGORIES_MENU, payload}
}

export function updateCartItems(payload) {
    return{type:types.UPDATE_CART_ITEMS, payload}
}

export function setCart(payload) {
    return{ type: types.SET_CART, payload};
}

export function setCartRequest(payload) {
    return{ type: types.SET_CART_REQUEST, payload};
}

export function setOrderDone(payload) {
    return{type:types.SET_ORDER_DONE, payload};
}

export function updateUserComment(payload) {
    return{type:types.UPDATE_USER_COMMENT, payload};
}

export function setTradeBenefitsChargeTypes(payload) {
    return{type:types.SET_TRADE_BENEFIT_CHARGE_TYPES, payload};
}

export function setBenefitTypesWhatRequireUserValidation(payload) {
    return{type:types.SET_TYPES_WHAT_REQUIRE_USER_VALIDATION, payload};
}

export function setHomePageBannersInterval(payload) {
    return{type:types.SET_HOME_PAGE_BANNERS_INTERVAL, payload};
}

export function SetHomePageSliderTypes(payload) {
    return{type:types.SET_HOME_PAGE_SLIDER_TYPES, payload};
}

export function SetVehicleAdDisplayTypes(payload) {
    return{type:types.SET_VEHICLE_AD_DISPLAY_TYPES, payload};
}

export function SetCarLeadServerError(payload) {
    return{type:types.SET_CAR_LEAD_SERVER_ERROR, payload};
}

export function SetTradeBenefitType(payload) {
    return{type:types.SET_TRADE_BENEFIT_TYPE, payload};
}

export function setMegaMenuMaxCategories(payload) {
    return{type:types.SET_MAX_CATEGORIES, payload};
}

export function setMegaMenuMaxSubCategories(payload) {
    return{type:types.SET_MAX_SUB_CATEGORIES, payload};
}

export function setNewsletterPopup(payload) {
    return{type:types.SET_NEWSLETTER_POPUP, payload};
}

export function setHomepageLogos(payload) {
    return{type:types.SET_HOMEPAGE_LOGOS, payload};
}

export function setMegaMenu(payload) {
    return{type:types.SET_MEGA_MENU, payload};
}

export function setInsuranceData(payload) {
    return { type: types.SET_INSURANCE_DATA, payload };
}

export function updateUserData(payload) {
    return { type: types.UPDATE_USER_DATA, payload };
}

export function setIsMarketingApproved(payload) {
    return { type: types.SET_IS_MARKETING_APPROVED, payload };
}

export function setIsConsentsUpdateSuccessful(payload) {
    return { type: types.SET_IS_CONSENTS_UPDATE_SUCCESSFUL, payload };
}

export function setUserLegalWaiverAgreements(payload) {
    return { type: types.SET_USER_WAIVER_AGREEMENTS, payload };
}

export function setDataSharingConfig(payload) {
    return { type: types.SET_DATA_SHARING_CONFIG, payload };
}

export function setParameter(payload) {
    return { type: types.SET_PARAMETER, payload };
}
